import { FormTemplate, BulletList, TextInput, TextLink, usePopupManager } from 'ui-builder';
import { Plan, usePlansAdminService } from 'nekst-api';
import React from 'react';
import { parseSetupAreaIdWithVersion, SetupAreaVersionMultiDropdown } from 'features/tasks-forms';
import { Popup } from 'features/nekst-widgets';
import useSettingsNavigator from '../../../../settings/settingsNavigator';

function CreatedPlansPopup(props: { plans: Plan[] }) {
  const settingsNavigator = useSettingsNavigator();

  const popupManager = usePopupManager();

  const getLinkForPlan = (plan: Plan) => {
    return settingsNavigator.getAdminMarketPlanLink(
      'nostate',
      plan._setupArea.id,
      plan._setupArea.version,
      plan.id
    );
  };

  const openPlanPage = (plan: Plan) => {
    settingsNavigator.openAdminMarketPlanPage(
      'nostate',
      plan._setupArea.id,
      plan._setupArea.version,
      plan.id
    );

    popupManager.closePopup();
  };

  return (
    <Popup
      title="Plans Created Successfully"
      content={(
        <div style={{ padding: '16px' }}>
          <p>Workflows in the following markets were created:</p>
          <ul style={{
            marginTop: '12px',
            paddingLeft: '20px'
          }}>
            <BulletList
              items={props.plans.map((plan) => (
                <TextLink
                  href={getLinkForPlan(plan)}
                  onClick={() => {
                    openPlanPage(plan);
                  }}
                >
                  {plan._setupArea.name} ({plan._setupArea.version})
                </TextLink>
              ))}
            />
          </ul>
        </div>
      )}
    />
  );
}

export interface CopyToGlobalPlanForm {
  plan: Plan,
}

export function CopyToGlobalPlanForm(props: CopyToGlobalPlanForm) {
  const planService = usePlansAdminService();
  const popupManager = usePopupManager();

  const handleAfterSubmit = async (plans: Plan[]) => {
    popupManager.openPopup(<CreatedPlansPopup plans={plans} />);
  };

  return (
    <FormTemplate<{ name: string, setupAreas: string[] }, Plan[]>
      title="Copy"
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true
          }
        },
        setupAreas: {
          type: 'array',
          constraints: {
            required: true
          }
        }
      }}
      submitFormFunc={async (data) => {
        return Promise.all(
          data.setupAreas.map(async (value) => {
            const id = parseSetupAreaIdWithVersion(value);

            return await planService.copyPlanAsGlobal(props.plan.id, {
              name: data.name,
              setupAreaId: id.setupAreaId,
              setupAreaVersion: id.setupAreaVersion
            });
          })
        );
      }}
      initialData={{
        name: props.plan.name,
      }}
      afterSubmitFunc={handleAfterSubmit}
    >
      <TextInput source="name" label="Workflow name" />
      <SetupAreaVersionMultiDropdown source="setupAreas" label="Market(s)" />
    </FormTemplate>
  );
}
